import { FormGroup } from '@angular/forms';
import { ReportFilterDto } from '../../../../../../types/dtos/reports.dto';

export abstract class BaseFilterStep {

  abstract form: FormGroup;

  abstract getForm(): FormGroup;

  abstract getStepFilter(): ReportFilterDto
}
